import { faUserPen } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import useStyles from './AssetPanelItemWrapper.styles';

const AssetPanelItemWrapper = ({
  children,
  styleHeaderAsSection,
  title,
  tooltipText
}: {
  children: React.ReactNode;
  styleHeaderAsSection?: boolean;
  title: string;
  tooltipText?: string;
}) => {
  const { classes } = useStyles({ styleHeaderAsSection });

  return (
    <Box className={classes.panelContentSection}>
      <Stack
        direction="row"
        sx={{ justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography className={classes.panelContentTitle}>{title}</Typography>
        {tooltipText && (
          <Tooltip title={tooltipText}>
            <FontAwesomeIcon size="xs" icon={faUserPen} />
          </Tooltip>
        )}
      </Stack>
      {children}
    </Box>
  );
};
export default AssetPanelItemWrapper;
